import React, { useEffect } from 'react';

const Kurumsal = () => {
  useEffect(() => {
    // Initialize AOS
    if (window.AOS) {
      window.AOS.init();
    }

    // Initialize Lucide Icons
    if (window.lucide) {
      window.lucide.createIcons();
    }
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="relative overflow-hidden pt-[72px] backdrop-blur-3xl">
        <div className="overlay"></div>
        <div className="stars" aria-hidden="true"></div>
        <div className="starts2" aria-hidden="true"></div>
        <div className="stars3" aria-hidden="true"></div>

        <div className="px-6 pt-20 overflow-hidden" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="800">
          <div className="container">
            <div className="py-14 text-center relative">
              <div className="flex justify-center">
                <div className="max-w-2xl">
                  <h2 className="md:text-6xl/tight text-5xl text-default-100 font-semibold mb-6">
                    <span className="bg-gradient-to-l from-rose-500 to-primary text-transparent bg-clip-text">Kurumsal</span>
                    <br />ISP Radius Hakkında
                  </h2>
                  <p className="text-sm font-medium text-default-400 mt-5">
                    Telekomünikasyon sektöründe güvenilir çözümler sunan ISP Radius, müşterilerinin ihtiyaçlarını karşılamak için sürekli gelişen bir teknoloji şirketidir.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Misyon Vizyon */}
      <section className="py-14">
        <div className="container">
          <div className="grid md:grid-cols-2 gap-6 items-center">
            <div data-aos="fade-right" data-aos-easing="ease" data-aos-duration="1000">
              <span className="py-1 px-3 rounded-md text-sm font-medium uppercase tracking-wider text-primary bg-primary/20">Misyonumuz</span>
              <h2 className="text-3xl/snug font-medium capitalize text-white mt-4">Teknoloji ile Güvenilir Hizmet</h2>
              <p className="text-base font-medium text-default-200 mt-5">
                ISP Radius olarak misyonumuz, telekomünikasyon sektöründe faaliyet gösteren işletmelere en güncel teknolojileri kullanarak güvenilir, hızlı ve kullanıcı dostu çözümler sunmaktır. Müşterilerimizin iş süreçlerini optimize etmek ve onlara rekabet avantajı sağlamak için sürekli gelişen bir platform sunuyoruz.
              </p>
            </div>

            <div data-aos="fade-left" data-aos-easing="ease" data-aos-duration="1000">
              <span className="py-1 px-3 rounded-md text-sm font-medium uppercase tracking-wider text-primary bg-primary/20">Vizyonumuz</span>
              <h2 className="text-3xl/snug font-medium capitalize text-white mt-4">Güvenilir ve Yenilikçi Çözüm Ortağı Olmak</h2>
              <p className="text-base font-medium text-default-200 mt-5">
                Telekomünikasyon sektöründe müşterilerimizin güvenilir çözüm ortağı olmak. Sürekli gelişen teknoloji ve değişen pazar ihtiyaçlarına uyum sağlayarak, müşterilerimize kaliteli ve etkili çözümler sunmayı hedefliyoruz. Sektörde tanınan ve tercih edilen bir marka olma yolunda ilerlemeye devam ediyoruz.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Değerlerimiz */}
      <section className="py-14">
        <div className="container">
          <div className="flex items-end justify-between mb-10">
            <div className="max-w-2xl mx-auto text-center">
              <h2 className="text-3xl font-medium capitalize text-white mb-4">Değerlerimiz</h2>
              <p className="text-sm text-default-200 font-medium">ISP Radius'un temel değerleri ve çalışma prensipleri</p>
            </div>
          </div>

          <div className="grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6">
            <div className="group p-8 rounded-xl bg-default-950/40 transition-all duration-500 hover:-translate-y-2 hover:bg-primary/40">
              <div className="h-14 w-14 flex items-center justify-center rounded-lg bg-primary/20 text-primary group-hover:bg-white/20 group-hover:text-white">
                <i data-lucide="shield-check" className="h-9 w-9"></i>
              </div>
              <h3 className="text-xl font-medium text-default-200 mt-8">Güvenilirlik</h3>
              <p className="text-base font-normal text-default-300 mt-4">Müşterilerimizin verilerini en üst düzeyde güvenlik önlemleri ile koruyoruz ve kesintisiz hizmet sunuyoruz.</p>
            </div>

            <div className="group p-8 rounded-xl bg-default-950/40 transition-all duration-500 hover:-translate-y-2 hover:bg-primary/40">
              <div className="h-14 w-14 flex items-center justify-center rounded-lg bg-primary/20 text-primary group-hover:bg-white/20 group-hover:text-white">
                <i data-lucide="zap" className="h-9 w-9"></i>
              </div>
              <h3 className="text-xl font-medium text-default-200 mt-8">İnovasyon</h3>
              <p className="text-base font-normal text-default-300 mt-4">Sürekli gelişen teknolojileri takip ederek müşterilerimize en güncel çözümleri sunuyoruz.</p>
            </div>

            <div className="group p-8 rounded-xl bg-default-950/40 transition-all duration-500 hover:-translate-y-2 hover:bg-primary/40">
              <div className="h-14 w-14 flex items-center justify-center rounded-lg bg-primary/20 text-primary group-hover:bg-white/20 group-hover:text-white">
                <i data-lucide="users" className="h-9 w-9"></i>
              </div>
              <h3 className="text-xl font-medium text-default-200 mt-8">Müşteri Odaklılık</h3>
              <p className="text-base font-normal text-default-300 mt-4">Müşterilerimizin ihtiyaçlarını öncelikli tutarak, onların başarısı için çalışıyoruz.</p>
            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default Kurumsal;
